import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Actions
import {
    requestLoadDocumentSets,
    canceledLoadDocumentSets
} from '../../../../services/documentSets/actions';

// Selectors
import { makeSelectParameters } from './selectors';

// Workspaces
import { selectTime } from '../../../../workspaces/redux-timekeeper';
import { makeSelectQueryStringNumberValue } from '../../../../workspaces/react-router-selectors';

interface Props {
    parameters: Record<string, any>;
    requestLoadDocumentSets: Function;
    canceledLoadDocumentSets: Function;
    newEvent?: number;
}

export class DocumentSetsRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.requestLoadDocumentSets();
    }

    componentDidUpdate(prevProps: Props) {
        // Update if request parameters change
        if (!isEqual(prevProps.parameters, this.props.parameters)) {
            this.props.requestLoadDocumentSets();
        }

        // Update if a new event is created
        if (this.props.newEvent && prevProps.newEvent !== this.props.newEvent) {
            this.props.requestLoadDocumentSets();
        }
    }

    componentWillUnmount() {
        this.props.canceledLoadDocumentSets();
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    time: selectTime,
    parameters: makeSelectParameters(),
    newEvent: makeSelectQueryStringNumberValue('newEvent')
});

export default connect(
    mapStateToProps,
    { requestLoadDocumentSets, canceledLoadDocumentSets }
)(DocumentSetsRequest);
